import React from 'react';
import { Stack, Text, Divider, Clickable } from '@moda/om';
import ExitIcon from '@moda/icons/exit-16';
import { SizeGuideFragment } from '../../generated/types';
import { ModalOverlay } from '../Modal';
import { SizeGuide } from './SizeGuide';
import './SizeGuideModal.scss';

type Props = {
  show: boolean;
  sizes: SizeGuideFragment[];
  sizeEquivalents: string[][];
  fitRecommendation?: string | null;
  onClose: () => void;
};

export const SizeGuideModal: React.FC<Props> = ({
  show,
  sizes,
  sizeEquivalents,
  fitRecommendation,
  onClose
}) => (
  // eslint-disable-next-line jsx-a11y/no-autofocus
  <ModalOverlay autoFocus={false} show={show} onClose={onClose}>
    <div className="SizeGuideModal">
      <Clickable className="SizeGuideModal__close" aria-label="Close" onClick={onClose}>
        <ExitIcon />
      </Clickable>
      <Stack space={4}>
        <Text
          data-test-id="size-guide-title"
          className="SizeGuideModal__title"
          treatment="h3"
          family="serif"
        >
          Size Guide
        </Text>
        <Divider />
        <SizeGuide
          className="SizeGuideModal__guide"
          sizes={sizes}
          sizeEquivalents={sizeEquivalents}
          fitRecommendation={fitRecommendation}
        />
        <Divider />
      </Stack>
    </div>
  </ModalOverlay>
);
